/**
 * `div.abrand` → `auth-card-brand` (process/08-COMPONENT-CATALOGUE.md). "The product lockup at
 * the head of the card." Copy is AUTH_BRAND (src/copy/registry.ts), shared by all 17 auth units.
 *
 * gap 9px → --sp-5 (+1px), margin-bottom 22px → --sp-10 (+2px); svg 24x24 is out of the token
 * map's scope (width/height); text 13px → --fs-body-lg (0 delta), weight 700 → --fw-bold.
 *
 * **Icon path corrected to the real `#f-shield` symbol (W173)** — this used to draw a
 * hand-approximated shield with no checkmark, predating `iconData.ts`/`Icon.tsx` (W156), which
 * already extracted `f-shield` (16×16, outline + a white checkmark path) verbatim and correctly.
 * **Still not switched to `<Icon name="f-shield">` (W175 fixed the fill bug that was the original
 * reason, but a second, unrelated one remains)**: this brand mark is drawn at 24×24, and `Icon.tsx`'s
 * own `SIZE_TOKEN` scale only offers 16/12/10px — composed directly here to get the real size, not
 * to work around `Icon.tsx` any longer.
 */
export function AuthCardBrand({ label }: { label: string }) {
  return (
    <div data-cmp="auth-card-brand" className="flex items-center gap-5 mb-10">
      <svg aria-hidden="true" viewBox="0 0 16 16" style={{ width: '24px', height: '24px' }} className="fill-blue stroke-none">
        <path d="M8 .7 1.9 3v5.1c0 3.6 2.5 6.1 6.1 7.2 3.6-1.1 6.1-3.6 6.1-7.2V3z" />
        <path d="M7.05 11.3 4.2 8.45l1.15-1.15 1.7 1.7 3.6-3.6 1.15 1.15z" fill="#fff" />
      </svg>
      <b className="text-body-lg font-bold">{label}</b>
    </div>
  )
}
